module.exports = __webpack_public_path__ + "media/images/pc/maedori_photowedding/mv_maedori_01@3x-e93ad8da7d1229762f0f6815215120b8.webp";